import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { Modal, NamedLink } from '../../components';
import css from './LoginPromptModal.module.css';

const LoginPromptModal = props => {
  const { id, isOpen, onClose, onManageDisableScrolling } = props;

  return (
    <Modal
      id={id}
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      containerClassName={css.modalContainer}
      usePortal
    >
      <div className={css.content}>
        <div className={css.iconWrapper}>
          <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={css.bookmarkIcon}
          >
            <path
              d="M5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21L12 17.5L5 21Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h2 className={css.title}>
          <FormattedMessage id="LoginPromptModal.title" />
        </h2>

        <p className={css.message}>
          <FormattedMessage id="LoginPromptModal.message" />
        </p>

        <div className={css.buttons}>
          <NamedLink
            name="LoginPage"
            className={css.loginButton}
          >
            <FormattedMessage id="LoginPromptModal.loginButton" />
          </NamedLink>

          <NamedLink
            name="SignupPage"
            className={css.signupButton}
          >
            <FormattedMessage id="LoginPromptModal.signupButton" />
          </NamedLink>
        </div>

        <button
          className={css.cancelButton}
          onClick={onClose}
        >
          <FormattedMessage id="LoginPromptModal.cancelButton" />
        </button>
      </div>
    </Modal>
  );
};

LoginPromptModal.defaultProps = {
  isOpen: false,
};

const { string, bool, func } = PropTypes;

LoginPromptModal.propTypes = {
  id: string.isRequired,
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  onManageDisableScrolling: func.isRequired,
};

export default LoginPromptModal;
